import { render, staticRenderFns } from "./BalanceListTable.vue?vue&type=template&id=00c27624&scoped=true&"
var script = {}
import style0 from "./BalanceListTable.vue?vue&type=style&index=0&id=00c27624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c27624",
  null
  
)

export default component.exports